import styled from 'styled-components';
import { Button, TextField } from '@mui/material';

export const Title = styled('div')(() => ({
  width: '30%',
  background: '#1976d2',
  color: 'white',
  textAlign: 'center',
  borderRadius: '5px',
  paddingTop: '8px',
}));

export const CloseButton = styled(Button)`
  border-radius: 50% !important;
  min-width: auto !important;
  width: 20px !important;
  line-height: 20px !important;
  padding: 2px;
`;

export const Header = styled.div`
  width: 94%;
  align-self: center;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const HeaderText = styled.h3`
  margin: unset;
  margin-top: 12px;
  margin-bottom: 5px;
  padding-left: 3px;
  color: rgba(0, 0, 0, 0.87);
`;

export const StyledTextField = styled(TextField)`
  & .MuiInputBase-input {
    color: #1f1f1fff;
    -webkit-text-fill-color: #1f1f1fff; /* Chrome/Safari (incl. autofill) */
  }
`;
